import { clsxCustom } from '@interlayer/js/custom/utils/clsx.util';

export * from '@core/js/utils/classNames.util.js';

export const clsx = clsxCustom;
